import {
  JupiterTheme,
  darkThemeStyles,
  MockHook,
  LoadingSpinner,
} from '@jupiterone/jupiter-web-toolkit';
import { createStyles, makeStyles } from '@material-ui/styles';
import React from 'react';
import useCompanyLogoSettingLogic, {
  CompanyLogoSettingComponentProps,
} from './useCompanyLogoSettingLogic';
import { Button, TextField } from '@material-ui/core';

import CompanyLogoLabel from './CompanyLogoLabel';

const useStyles = makeStyles((theme: JupiterTheme) => {
  return createStyles({
    textInputLabelDisabled: {
      ...darkThemeStyles.textInputLabelDisabled,
    },
    textInputLabelFocused: {
      ...darkThemeStyles.textInputLabelFocused,
    },
    disabled: {
      ...darkThemeStyles.disabled,
    },
    textInputLabel: {
      ...darkThemeStyles.textInputLabel,
    },
    textInput: {
      ...darkThemeStyles.textInput,
    },

    formRoot: {
      color: theme.palette.text.contrast,
      width: '100%',
    },

    buttonRoot: {
      height: 38,
      marginTop: theme.spacing(2),
    },
    white: {
      color: theme.palette.text.contrast,
    },
    companyLogoSettingRoot: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      alignItems: 'flex-end',
      justifyContent: 'space-between',
      margin: theme.spacing(1, 0),
    },
    customLogoSettings: {
      width: '100%',
    },
  });
});

export const CompanyLogoSettingComponent = ({
  handleSubmit,
  handleChange,
  imageUrlValue,
  isAdmin,
  disabled,
  loading,
  hasUrlChanged,
}: CompanyLogoSettingComponentProps) => {
  const classes = useStyles();
  const InputLabelProps = {
    className: classes.textInputLabel,
    classes: {
      disabled: classes.textInputLabelDisabled,
      focused: classes.textInputLabelFocused,
    },
  };
  const InputProps = {
    className: classes.textInput,
    classes: {
      disabled: classes.disabled,
      icon: classes.white,
    },
  };
  return isAdmin ? (
    <div className={classes.companyLogoSettingRoot}>
      {loading ? (
        <LoadingSpinner />
      ) : (
        <>
          <form onSubmit={handleSubmit} className={classes.formRoot}>
            <TextField
              label={<CompanyLogoLabel disabled={disabled} />}
              value={imageUrlValue}
              InputLabelProps={InputLabelProps}
              InputProps={InputProps}
              onChange={handleChange}
              margin="normal"
              fullWidth
              disabled={disabled}
            />
          </form>
          <Button
            className={classes.buttonRoot}
            variant="contained"
            onClick={handleSubmit}
            disabled={!isAdmin || disabled || !hasUrlChanged}
            color="primary"
          >
            Save Logo Url
          </Button>
        </>
      )}
    </div>
  ) : (
    <span />
  );
};

export default MockHook.withHookHoc(
  CompanyLogoSettingComponent,
  useCompanyLogoSettingLogic
);
